/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InvestmentEntity} from '@cash-web/protos/squareup/cash/marketdata/model/investment_entities.pb'


export const update = (request: InvestmentEntity, options?: CashRequestOptions) => post<InvestmentEntity, InvestmentEntity>("/2.0/cash/update", request, {...options, rejectOnError: true })